/**
 * @Author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 2020-Oct-22
 *
 * bestgob-client - processes.module.js
 **/
 import processesRequestModel from "../api/models/process/list.request";
 import {GeneralApi, Processes} from "../api";
 import {processRequirementsRequest} from "../api/models";
 
 const processesModule = {
     namespaced: true,
     state: {
         processes: null,
         categories: null,
         categoriesHome: null,
         processRequirements: null,
         processRequirementsShow: true,
         processName: null,
         AllProcessByCategory: null,
         AllProcessByCategoryHome: null,
         FrequentProcedure: null,
         documentStatusSucces: null,
     },
     getters: {
 
     },
     actions: {

        async getFrequentProcesses({commit, dispatch}, request = processesRequestModel()){
         
            Processes.getFrequentProcedure(request)
                .then(data => {
                    console.log(JSON.stringify(data))
                    // dispatch('alerts/hideLoading', null, {root: true})
                    commit('getFrequentProcesses', data)
                })
                .catch(error => {
                    dispatch('alerts/error', error.message, {root: true})
                })
        },

         async getAllProcessByCategoryHome({commit, dispatch}, length, request = processesRequestModel() ){
             //console.log('home');
             dispatch('alerts/showLoading', 'Obteniendo listado de procesos', {root: true})
            //  await dispatch('account/checkAuthExpiration', null, { root: true })
 
             // console.log( JSON.stringify( this.state.processes.categories) );
 
             let aux = []
             for (let i = 1; i <= length ; i++) {
                 request.category_id = i
                 request.type_of_person = 'fisica'
 
                 await Processes.getByCategoryHome(request)
                     .then(data => {
                         aux.push(data)
                     })
                     .catch(error => {
                         dispatch('alerts/error', error.message, {root: true})
                     })      
             }
 
            console.log(aux);
            commit('getAllProcessByCategoryHome',aux)
            dispatch('alerts/hideLoading', null, {root: true})
         },

         async getAllProcessByCategory({commit, dispatch}, length, request = processesRequestModel() ){
             dispatch('alerts/showLoading', 'Obteniendo listado de procesos', {root: true})
             await dispatch('account/checkAuthExpiration', null, { root: true })
 
             console.log('--con session');
             // console.log( JSON.stringify( this.state.processes.categories) );
 
             let aux = []
             for (let i = 1; i <= length ; i++) {
                 request.category_id = i
                 request.type_of_person = 'fisica'
 
                 await Processes.getByCategory(request)
                     .then(data => {
                         aux.push(data)
                     })
                     .catch(error => {
                         dispatch('alerts/error', error.message, {root: true})
                     })      
             }
 
            console.log(aux);
            commit('getAllProcessByCategory',aux)
            dispatch('alerts/hideLoading', null, {root: true})
         },
 
         async getProcesses({commit, dispatch}, request = processesRequestModel()){
             dispatch('alerts/showLoading', 'Obteniendo listado de procesos', {root: true})
             await dispatch('account/checkAuthExpiration', null, { root: true })
 
             Processes.getByCategory(request)
                 .then(data => {
                     console.log(JSON.stringify(data))
                     dispatch('alerts/hideLoading', null, {root: true})
                     commit('getProcessesSuccess', data)
                 })
                 .catch(error => {
                     dispatch('alerts/error', error.message, {root: true})
                 })
         },
 
         async getCategories({commit, dispatch}){
             dispatch('alerts/showLoading', 'Obteniendo listado de categorías', {root: true})
             await dispatch('account/checkAuthExpiration', null, { root: true })
 
            await Processes.getCategories()
                 .then(data => {
                    //  dispatch('alerts/hideLoading', null, {root: true})
                     commit('getCategoriesSuccess', data)
                 })
                 .catch(error => {
                     dispatch('alerts/error', error.message, {root: true})
                 })
         },

         async getCategoriesHome({commit, dispatch}){
             dispatch('alerts/showLoading', 'Obteniendo listado de categorías', {root: true})
             await dispatch('account/checkAuthExpiration', null, { root: true })
 
            await Processes.getCategoriesinHome()
                 .then(data => {
                    //  dispatch('alerts/hideLoading', null, {root: true})
                     commit('getCategoriesinHomeSuccess', data)
                 })
                 .catch(error => {
                     dispatch('alerts/error', error.message, {root: true})
                 })
         },
 
         async getProcessRequirements({commit, dispatch}, request = processRequirementsRequest()){
             dispatch('alerts/showLoading', 'Obteniendo información del proceso', {root: true})
             await dispatch('account/checkAuthExpiration', null, { root: true })
 
             Processes.getProcessRequirements(request.processId, request.invited, request.userId, request.sessionUser)
                 .then(data => {
                     dispatch('alerts/hideLoading', null, {root: true})
                     commit('getRequirementsSuccess', data)
                 })
                 .catch(error => {
                     dispatch('alerts/error', error.message, {root: true})
                 })
 
         },
 
         async getProcessDetails({commit, dispatch}, processId= 0){
             dispatch('alerts/showLoading', 'Obteniendo los detalles del proceso', {root: true})
 
             await dispatch('account/checkAuthExpiration', null, { root: true })
 
             Processes.getDetailsAndTasks(processId)
                 .then(data => {
                     //dispatch('alerts/hideLoading', null, {root: true})
                     commit('getProcessDetailsSucccess', data)
                 })
                 .catch(error => {
                     dispatch('alerts/error', error.message, {root: true})
                 })
         },

         async getDocumentByPaymentStatus({commit, dispatch}, folio ) {
            dispatch('alerts/showLoading', 'Obteniendo el estatus del pago', {root: true})
            console.info(folio);
            GeneralApi.validatePaid(folio)
            .then(data => {
                commit('getDocumentByPaymentStatusSuccess', data)
                dispatch('alerts/hideLoading', null, {root: true})
            })
            .catch(error => {
                dispatch('alerts/error', `${folio}, ${error.message}`, {root: true})
            })

         }
     },
 
     mutations: {
         getProcessesSuccess(state, processes){
             state.processes = processes
         },
 
         getAllProcessByCategory(state, processes){
             state.AllProcessByCategory = processes
         },

         getAllProcessByCategoryHome(state, processes){
             state.AllProcessByCategoryHome = processes
         },

         getFrequentProcesses(state, processes){
             state.FrequentProcedure = processes
         },
         
         getCategoriesSuccess(state, categories){
             state.categories = categories
         },

         getCategoriesinHomeSuccess(state, categories){
             state.categoriesHome = categories
         },
 
         getRequirementsSuccess(state, processRequirements){
             state.processRequirements = processRequirements.contents
             state.processRequirementsShow = processRequirements.show
         },
 
         getProcessDetailsSucccess(state, processDetails){
             state.processName = processDetails.tareas.proceso
         },
         getDocumentByPaymentStatusSuccess(state, DocumentByPaymentStatusSuccess){
             state.documentStatusSucces = DocumentByPaymentStatusSuccess
         }
     }
 }
 
 export default processesModule